import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { StarFill, RatingStar } from '../../../assets/icons'
import breakpoints from '../../../theme/breakpoints'

type RuleNames = 'star' | 'span'

interface StyleProps {
    size: number
    useOnClick: boolean
    right?: string
    bottom?: string
}

interface Props {
    active: boolean
    onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
    size?: number
    right?: string
    bottom?: string
}

const useStyles = createUseStyles<RuleNames, StyleProps, Jss.Theme>(() => ({
    star: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        boxSizing: 'border-box',
        textDecoration: 'none',
        aspectRatio: '1/1',
        textAlign: 'center',
        transition: 'all 0.2s',
        boxShadow: 0,
        border: '2px solid #fff',
        backgroundColor: '#F5F6F8',
        '&:hover': {
            cursor: ({ useOnClick }) => (useOnClick ? 'pointer' : 'inherit'),
            backgroundColor: '#ffffff',
        },
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        position: 'absolute',
        right: ({ size, right }) => {
            return right || `-${size / 3}px`
        },
        bottom: ({ size, bottom }) => {
            return bottom || `-${size / 2}px`
        },
        top: 'auto',
        // bottom: 0,
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            '&': {
                // top: '0',
                // bottom: 'auto',
            },
        },
    },
    span: {
        display: 'none',
    },
}))

const Favorite: React.FC<Props> = ({
    active,
    onClick,
    size = 14,
    right,
    bottom,
}) => {
    const theme = useTheme<Jss.Theme>()
    const useOnClick = !!onClick
    const classes = useStyles({ ...{ size, useOnClick, right, bottom }, theme })

    const width = size ? `${size}px` : '14px'

    return (
        <button type="button" onClick={onClick} className={classes.star}>
            {active && <StarFill width={width} color="#F1C400" />}
            {!active && <RatingStar width={width} color="#297A71" />}
        </button>
    )
}

export { Favorite }
